import * as React from 'react';
import { ValueProperty } from 'app/types-shared';
import { Options, LoadOptions } from 'ui';

export interface LoadOptionsProps {
  sortDirection?: 'asc' | 'desc';
  displayNotSelected?: boolean;
}

/**
 * Loads options after component is mounted.
 */
export const withOptionLoading = <TOptionValue extends ValueProperty> () => <TProps extends Options<TOptionValue> & LoadOptionsProps>(
  WrappedComponent: React.ComponentClass<TProps>
): React.ComponentClass<TProps> => {
  return class extends React.Component<TProps> {
    public componentDidMount() {
      const loadOptions : LoadOptions = {
        sort: this.props.sortDirection,
        displayNotSelected: this.props.displayNotSelected
      };

      !this.props.options && this.props.onLoadOptions(loadOptions);
    }

    public render() {
      return (
        <WrappedComponent {...this.props} />
      );
    }
  };
};
